import React from 'react';
import PropTypes from 'prop-types';
import { TopToolbar, ListButton } from 'react-admin';

const SktFragmentActions = ({ basePath, data }) => (
  <TopToolbar>
    <ListButton basePath={basePath} record={data} />
  </TopToolbar>
);

SktFragmentActions.propTypes = {
  basePath: PropTypes.string,
  data: PropTypes.shape({}),
};

SktFragmentActions.defaultProps = {
  basePath: '',
  data: {},
};

export default SktFragmentActions;
